module.exports = "/_next/static/images/app-intro-device-diputi@2x-min-58e25129aa6f500f9da43e524f59c1cf.png.webp";